// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"203":"1dd88a1e","538":"557fadf1","785":"d2ab0ca5"}[chunkId] + ".chunk.js";
};